import React from "react";

// Local Imports
import LuxuraiPostcard from "../../images/graphic_design/luxurai-fictional-real-estate-postcard.jpg";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function GD_Project_5() {
  // Luxurai Postcard
  const openPopupBoxLuxuraiPostcard = () => {
    const content = (
      <>
        <div className="image-center">
          <img
            className="portfolio-image-90"
            src={LuxuraiPostcard}
            alt="Screenshot of Luxurai Postcard"
          />
        </div>
        <p>
          A fictional postcard to demonstrate layout, logo creation, and design
          skills - I do not claim the photography
        </p>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "Luxurai Postcard",
        },
      },
    });
  };

  const popupboxConfigLuxuraiPostcard = {
    titleBar: {
      enable: true,
      text: "Luxurai Postcard",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div
        className="portfolio-image-box"
        onClick={openPopupBoxLuxuraiPostcard}
      >
        <img
          className="portfolio-image constraints image-top-center"
          src={LuxuraiPostcard}
          alt="Screenshot of Luxurai Postcard"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigLuxuraiPostcard} />
    </>
  );
}

export default GD_Project_5;
